import React from "react";
import PropTypes from "prop-types";

import IconUTDGradient from "../../icons/IconUTDGradient";

const AboutOurMission = ({ subtitle, title, text }) => {
	if (!subtitle && !title && !text) {
		return null;
	}

	return (
		<section className="about-our-mission">
			<div className="about-our-mission__container">
				<div className="about-our-mission__logo">
					<IconUTDGradient/>
				</div>

				{subtitle &&
					<h2 className="about-our-mission__label">
						{subtitle}
					</h2>
				}

				{title &&
					<p className="about-our-mission__title">
						{title}
					</p>
				}

				{text &&
					<div className="about-our-mission__text" dangerouslySetInnerHTML={{ __html: text }}/>
				}
			</div>
		</section>
	);
};

AboutOurMission.propTypes = {
	subtitle: PropTypes.string,
	title: PropTypes.string,
	text: PropTypes.string
};

export default AboutOurMission;
